import { useDevice } from '@contexts/device';
import Skeleton from '@components/skeletons/Skeleton';
import { FlexibleDiv } from '@components/formStyles';

import { ContentWrapper, Items } from './styled';

const CampaignsSkeleton = () => {
  const { isDesktop } = useDevice();
  return (
    <FlexibleDiv top={40}>
      <ContentWrapper>
        <FlexibleDiv bottom={18}>
          <Skeleton width={120} height={15} borderRadius={8} />
        </FlexibleDiv>

        <FlexibleDiv bottom={15}>
          <Skeleton width={207} height={51} borderRadius={8} />
        </FlexibleDiv>

        <FlexibleDiv bottom={40}>
          <Skeleton
            width={isDesktop ? 700 : 300}
            height={isDesktop ? 51 : 100}
            borderRadius={8}
          />
        </FlexibleDiv>

        <Items>
          {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
            <Skeleton key={item} height={isDesktop ? 360 : 200} />
          ))}
        </Items>
      </ContentWrapper>
    </FlexibleDiv>
  );
};

export default CampaignsSkeleton;
